var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EA9F2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 25.9991C20.1797 25.9991 26 20.1788 26 12.9991C26 10.7622 25.435 8.65726 24.44 6.81918C22.1544 4.82167 19.1631 3.61142 15.8892 3.61142C8.70946 3.61142 2.88916 9.43172 2.88916 16.6114C2.88916 18.8483 3.45414 20.9533 4.44917 22.7914C6.7348 24.7889 9.72607 25.9991 13 25.9991Z",
    fill: "#F5AB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5312 16.5857H5.46875C5.20984 16.5857 5 16.7957 5 17.0546C5 17.3134 5.20984 17.5233 5.46875 17.5233H20.5312C20.7902 17.5233 21 17.3134 21 17.0546C21 16.7957 20.7902 16.5857 20.5312 16.5857Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.819 14.2201C18.6011 13.8461 18.2716 13.6316 17.9147 13.6316C17.9144 13.6316 17.9142 13.6316 17.9139 13.6316C17.5571 13.632 17.2279 13.8467 17.0109 14.2208L17.0079 14.2258C17.0015 14.2373 16.995 14.2489 16.9883 14.2606L14.3712 9.72742C14.1047 9.26562 13.7059 9.00049 13.2771 9C13.2767 9 13.2764 9 13.2759 9C12.847 9 12.4475 9.26477 12.1793 9.72742C12.1793 9.72742 11.3254 11.2073 10.777 12.1573C10.6917 12.0098 10.6267 11.8972 10.625 11.8944C10.3588 11.4324 9.95984 11.1671 9.53076 11.1667C9.53052 11.1667 9.53027 11.1667 9.52991 11.1667C9.10083 11.1667 8.70142 11.4318 8.43396 11.8942L6.28638 15.6147L6.26709 15.6482H19.6429C19.3712 15.1797 19.0308 14.5892 18.819 14.2201Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuest);
export default __webpack_public_path__ + "static/media/quest.eae2f07572f867ef84fc4b3eb7cc248b.svg";
export { ForwardRef as ReactComponent };